import { Location } from "./types";

function areLocationsEqual(a: Location, b: Location) {
  return a.row === b.row && a.col === b.col;
}

export default areLocationsEqual;
